module.exports = __webpack_public_path__ + "img/3iKXI4vqItbSTG94rMNyjK.ee24c6f0.svg";